import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import store from '../../../redux/stores/store'
import './menu.scss'
import Item from './item/item.component'
import { MENU_ACTIVE_ITEM, MENU_TOGGLE } from '../../../redux/reducers/menu/action-types'
import imageLogo from '../../../assets/images/logo.png'
import IconLogout from '../../../assets/icons/logout'

class Menu extends React.Component {

    constructor(props) {
        super(props)
        this.state = { ...props.menu }
    }

    componentDidMount = () => {
        this.unsubscribe = store.subscribe(() => {
            this.setState(store.getState().menu)
        })
        this.setActiveItem()
    }

    onItemClick = (key) => {
        key === 0 && this.props.history.push('/')
        this.props.dispatch({
            type: MENU_ACTIVE_ITEM,
            payload: {
                key: key
            }
        })

        const url = this.props.menu.items[key].url

        if (this.props.location.pathname === url) {
            window.location.reload()
            return
        } else {
            this.props.history.push(url)
        }
    }

    setActiveItem = () => {
        if (this.props.location.pathname === "/") {
            this.props.dispatch({
                type: MENU_ACTIVE_ITEM,
                payload: {
                    key: 0
                }
            })
        }
        else {
            this.props.menu.items.forEach((item, key) => {
                let routes = this.props.location.pathname.split('/')
                if (typeof item.url !== 'undefined' && item.url.includes("/" + routes[2])) {
                    this.props.dispatch({
                        type: MENU_ACTIVE_ITEM,
                        payload: {
                            key: key
                        }
                    })
                    return
                }
            })
        }
    }

    onSubItemClick = url => {
        if (this.props.location.pathname === url) {
            window.location.reload()
            return
        }
        this.props.dispatch({
            type: MENU_TOGGLE,
            payload: {}
        })
    }

    componentWillUnmount = () => {
        this.unsubscribe()
    }

    onTogglerClick = () => {
        this.props.dispatch({
            type: MENU_TOGGLE,
            payload: {}
        })
    }

    onLogout = () => {
        sessionStorage.removeItem("auth")
        window.document.location = '/auth/login'
    }

    render() {
        return (
            <div className={this.state.showMenu ? 'menu active' : 'menu'}>
                <div className="logo">
                    <img src={imageLogo} alt="" />
                    <h1>
                        NBA<br/> Effurun Branch
                    </h1>
                    <div className="toggler" onClick={this.onTogglerClick}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
                <div className="space"></div>
                <ul>
                    {
                        this.props.menu.items.map(
                            (menu, key) => <Item key={key} active={(this.state.activeItem === key)} onClick={() => this.onItemClick(key)} {...menu} />
                        )
                    }
                </ul>
                <div className='profile'>
                    <div className="name">
                        {this.props.auth.profile.firstname[0]}{this.props.auth.profile.lastname[0]}
                    </div>
                    <div className='logout' onClick={this.onLogout}>
                        <IconLogout/>
                        <h4>Logout</h4>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        menu: state.menu,
        auth: state.auth
    }
}

export default connect(mapStateToProps)(withRouter(Menu))